<app-nav titulo="Tipos de Descuento" descripcion="Configuración de los tipos de descuento disponibles en la calculadora de cotización.">
    <div class="tipos-descuento">

        <div class="descuento-producto-box">
            <div class="descuento-producto-info">
                <span class="descuento-producto-title">Descuento de producto — global · tasa fija</span>
                <span class="descuento-producto-description">Se aplica a todos los productos, sobre el precio de lista. No se elige en el cotizador.</span>
            </div>
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Tasa</mat-label>
                <input matInput type="number" [formControl]="descuentoProductoControl" style="text-align: right;">
                <span matSuffix>&nbsp;%</span>
            </mat-form-field>
            <button mat-raised-button color="primary" class="garantor-button" (click)="saveDescuentoProducto()">
                Guardar
            </button>
        </div>

        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="tiposDescuento"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updatePage($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
        <button mat-raised-button class="garantor-button add-button" color="primary" routerLink="./nueva">
            <mat-icon matPrefix>add</mat-icon>
            <span>Nuevo tipo de descuento</span>
        </button>
    </div>
</app-nav>

<ng-template #topeColumnTemplate let-row="row">
    máx {{ row.tope }}%
</ng-template>

<ng-template #activoColumnTemplate let-row="row">
    <span [class]="row.activo ? 'status-badge active' : 'status-badge inactive'">
        {{ row.activo ? 'Activo' : 'Inactivo' }}
    </span>
</ng-template>

<ng-template #actionsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Editar" [routerLink]="'./' + row.id + '/editar'">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Dar de baja" (click)="deleteTipoDescuento(row)">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
